import en from './locale/en';

export default {
  // Locale value
  locale: 'en',

  // Fallback locale
  localeFallback: 'en',

  // Detect locale by checking browser language
  detectLocale: 1,

  // Show warnings when some of the i18n resources are missing
  debug: 0,

  // Messages to translate
  messages: {
    en
  }
};
